<template>
  <div class="page-appeal">

    <h2>インターン経験</h2>

    <div class="intern-content">
      <h3>株式会社ナイア</h3>
      <p> 2017年10月〜 2018年6月まで <br>
        個人事業主の元でアルバイト。受託開発のサポートで有名なアプリの開発に携われた。
        iOSの音声入力機能の検証やCoraImageで動画にフィルターをかけたり、YoutubeSDKを使ったプロトタイプ作成など、技術検証や開発の補助をした。
        また画像編集ライブラリを作成した。設計とかすごく悩んだし完全にググってごり押して作成したが一通り完成した。
      </p>
    </div>

    <div class="intern-content">
      <h3>合同会社インプリ</h3>
      <p> 2017年4月〜 2018年3月まで <br>
      調べればなんでもできる自信があったので色々なことに挑戦した。
      </p>
        <h4>①Unityでクロスワードのアプリを改修してリリースした。</h4>
        <p>初めてUnityを触ったが学習スピードの速さを生かし、50時間程度でUIの修正を完了した。</p>

        <h4>②求人検索アプリのAPIをGo言語で作成した</h4>
        <p>goのechoというライブラリを使って作成した。RESTFULな設計を調べて実装した。Amazon linuxに環境構築supervisorの導入やcloud watchのlog監視など調べて色々やった</p>

        <h4>③求人検索アプリにプッシュ通知を送るシステムの構築</h4>
        <p>言語はrubyを使った。FCMのAPIを叩く。phpMyAdminで通知のテキストを入力(LogPush的なUI)
          最終ログインが3日前、1週間前と通知を送るユーザーを細かく指定できるようにした。
        </p>

        <h4>④漫画アプリや求人検索アプリのアプデ対応</h4>
        <p>swiftで開発の補助。チュートリアル画面の追加、UIの修正、検索履歴を表示
          objctiveC -> swift やsqlite -> realmの firebaseの導入などの開発サポート
        </p>

        <h4>⑤radickerのアプリから再生機能を切り抜き</h4>
        <p>こちらのアプリからラジオの再生する機能を抜き出した。
          クラウドワークスで10万円で掲載していたらしく、10時間で達成したので初の時給1万円を達成した。
          最終回ボーナス。
        </p>
      </div>

      <div class="intern-content">
        <h3>株式会社ラボック</h3>
        <p> 2017年2月〜 2017年7月まで <br>
          mac book pro とディスプレイを貸していただいたので
          独学でiOSアプリを作れるようになった。
          当時は本を使わずにネットにある情報だけでやった。
          xcodeの使い方 swiftの文法 AVFondationで動画処理、APIを叩いてレスポンスを表示するなど
          一通り勉強した。
        </p>
      </div>

      <div class="intern-content">
        <h3>短期インターン</h3>
        <h4>cookpad spring 1 day サービス開発</h4>
        <p>学生が4人で数時間話せば一応アイデアが固まるのかと関心。</p>
        <h4>git push hackerthon 提出</h4>
        <p>入賞はできなかったが、最低要件を満たして提出した</p>
        <h4>株式会社Candle (30時間程度)</h4>
        <p>仮想通貨系のアプリで取引所のAPIの実装をした。大学辞める辞めないで続けられなかった。</p>
      </div>

    </div>
  </template>

<script>

export default {
  name: 'Appeal',
  data()  {
    return {
      text: "ios/swift/objctive-C/xcode/mysql/sqlite/realm/ruby/ruby on rails/javascript/react/vue"
    }
  }
}

</script>

  <style scoped>

  .page-appeal {
    /* height: 2000px; */
    /* background-color: red; */
    text-align: center;
    margin-bottom: 100px;
  }

  /* page-appeal classを指定したdivタグの子要素のpタグに適応 */
  div.page-appeal p {
    font-size: 18px;
    color: darkgray;
  }

  div.page-appeal h2 {
    color: pink;
  }

  div.intern-content {
    display: inline-block;
  }
  /*  モバイルなら*/
  @media screen and (max-width:781px) {
    div.intern-content  {
      width: 90%;
    }
  }
  /*  WEBなら*/
  @media screen and (min-width:781px) {
    div.intern-content  {
      width: 60%;
    }
  }

  div.intern-content p, div.intern-content h3, div.intern-content h4  {
    text-align: left;
  }
  </style>



// WEBPACK FOOTER //
// src/pages/Appeal.vue